import React, { useState, useEffect } from "react";
import Table2 from "../Table2/Table2";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import ReactLoading from 'react-loading';
import { loadUsers } from "../../Redux/Actions/ActionAuth";
import './Users.css'
import def from '../../images/def1.png'
import SinglePagenation from "../General/Pagination/SinglePagenation";

function AllUsers() {
    let dispatch = useDispatch();
    const users = useSelector(state => state.auth.users)
    const loadingUsers = useSelector(state => state.auth.loadingUsers)
    let langLocal = localStorage.getItem('absherLang');
    const [pageNumber, setPageNumber] = useState(0);
    const [t, i18n] = useTranslation();
    useEffect(() => {
        i18n.changeLanguage(localStorage.getItem('absherLang'));
        dispatch(loadUsers())
    }, []);
    const [activeCard, setActiveCard] = useState(1);

    const handleCardHover = (index) => {
        setActiveCard(index);
    };
    const usersPerPage = 12;
    const pagesVisited = pageNumber * usersPerPage;
    const displayUsers = users.slice(
        pagesVisited,
        pagesVisited + usersPerPage
    );

    const pageCount = Math.ceil(users.length / usersPerPage);
    const changePage = ({ selected }) => {
        setPageNumber(selected);
    };
    return (
        <>
            <main>
                <div className="page_header" dir={langLocal == "ar" ? "rtl" : "ltr"} >
                    <h2>{t('users')}</h2>
                </div>
                <div className="div_table" dir={langLocal == "ar" ? "rtl" : "ltr"} >
                    <div className="alluser" >

                        {
                            loadingUsers == false ? (
                                displayUsers.map((uu) => {
                                    return (
                                        <div className={`oneUser ${activeCard === uu.id ? 'activeUser' : ''}`}
                                        onMouseEnter={() => handleCardHover(uu.id)} >
                                            {
                                                uu.avatar === null ? (
                                                    <img src={def} />
                                                ):<img src={uu.avatar} />
                                            }
                                            <h2>{uu.name}</h2>
                                            <h5>{uu.phone}</h5>
                                            <h4>{uu.email}</h4>
                                        </div>

                                    )
                                })
                            ) : <div className="div_loading_normal" ><ReactLoading type="spinningBubbles" color="#36ADB0" height={'7%'} width={'7%'} /></div>
                        }
                    </div>
                </div>
                <br></br><br></br>
                <SinglePagenation pageCount={pageCount} changePage={changePage} />
                <br></br><br></br>
            </main>
        </>
    );
}

export default AllUsers;
